import { CSpinner } from '@coreui/react';
import * as React from 'react';

interface IProps {
}

// Affiche un spinner en plein écran pour indiquer que l'application travaille
export class KLoadingPanel extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="KLoadingPanel">
                    <CSpinner style={{ zIndex:2500, width: '5rem', height: '5rem', position: 'absolute', top: '45%', left: '47%' }} />{' '}
                </div>
            </React.Fragment>
        );
    }
}
